module.exports = __webpack_public_path__ + "static/media/04-Banque-Mondiale.71e12151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_banque-mondiale/04-Banque-Mondiale.jpg
// module id = 1183
// module chunks = 37